



















import { Component, Vue } from 'vue-property-decorator';
import chargesDB from '../server/init';
import moment from 'moment';


@Component({})
export default class OrderConfirmation extends Vue {
  private data() {
    return {
      orderId: this.$route.params.order,
      orderName: '',
      orderDate: '',
      deliveryDate: '',
      orderItems: []
    }
  }

  created() {
    chargesDB.collection('charges').get()
    .then((snapshot) => {
      snapshot.forEach((doc) => {
        const order = doc.data();
        if ( order.orderId === this.$data.orderId) {
          this.$data.orderName = order.name
          this.$data.orderDate = order.orderDate
          this.$data.deliveryDate = moment(order.orderDate).add(3, 'w').format('MM/DD/YYYY');
          this.$data.orderItems.push(order.orderItems);
          this.$data.orderLoading = false;
        }
      });
    });
  }
}
